import { FC, useMemo } from "react"
import Card from "./Card"
import Button from "./Button"
import { Link } from "react-router-dom"
import { Challenge } from "../sdk"
import Row from "./Row"
import Tag from "./Tag"

type Props = {
  challenge: Challenge
  className?: string
}

const ChallengeCard: FC<Props> = ({
  challenge,
  className
}) => {
  const {
    id,
    training,
    name,
    startTimestamp,
    endTimestamp,
    inProgress,
    finished,
    individual,
    startSubscriptionTimestamp,
    endSubscriptionTimestamp,
    draft,
    difficulty,
    visible
  } = challenge

  const status = useMemo(() => {
    const now = new Date().toISOString()
    return (
      inProgress
        ? "Live"
        : finished
          ? "Conclusa"
          : now < startSubscriptionTimestamp
            ? "Pre-iscrizione"
            : now < endSubscriptionTimestamp
              ? "Iscrizione"
              : now < startTimestamp
                ? "Pre-gara"
                : now < endTimestamp
                  ? "Live"
                  : "Conclusa"
    )
  }, [challenge])

  return (
    <Card
      className={className}
      heading={
        <Row justify="between">
          <div>{name}</div>

          <Tag theme={draft ? "yellow" : "blue"}>{
            draft
              ? "Bozza"
              : training
                ? "Training"
                : "Challenge"
          }</Tag>
        </Row>
      }
    >
      <div className="mb-2">
        {!training &&
          <Row className="card__row" justify="between">
            <div className="card__row-title">Tipologia</div>

            <div>{individual ? "Singolo" : "Team"}</div>
          </Row>
        }

        {!training &&
          <Row className="card__row" justify="between">
            <div className="card__row-title">Stato</div>

            <div>{status}</div>
          </Row>
        }

        <Row className="card__row" justify="between">
          <div className="card__row-title">Visibilità</div>

          <div>{visible ? "Visibile" : "Non visibile"}</div>
        </Row>

        {training && difficulty &&
          <Row className="card__row" justify="between">
            <div className="card__row-title">Difficoltà</div>

            <div>{difficulty}/5</div>
          </Row>
        }
      </div>

      <div className="text-center">
        <Link to={`/challenge/${id}`}>
          <Button>
            Vedi {draft ? "bozza" : training ? "training" : "challenge"}
          </Button>
        </Link>
      </div>
    </Card>
  )
}

export default ChallengeCard
